module.exports = __webpack_public_path__ + "5ff5d3c6a99ce2756869d3b9676e462c.pdf";